import React from 'react';
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CardSimple from 'screens/components/basic/CardSimple';
import SelectInput from 'screens/components/basic/SelectInput';

const componentName = "RevenueReport";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                    hintText={LOOKUP.report.common.endDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    defaultValue={props.loggedBranch.toString()}
                    label={LOOKUP.report.common.branch + "*"}
                    floatingLabelText={LOOKUP.report.common.branch + "*"}
                    hintText={LOOKUP.report.common.branch + "*"}
                    options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3">
                <SelectInput
                    name={componentName + "IsCannabis"}
                    fullWidth={true}
                    defaultValue="2"
                    label={"Parent Category"}
                    floatingLabelText={"Parent Category"}
                    hintText={"Parent Category"}
                    options={props.isCannabisOptions && props.isCannabisOptions.length > 0 ? props.isCannabisOptions : []}
                />
            </div>  {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl-4 m-0">
                <SelectInput
                    name={componentName + LOOKUP.report.common.categoryName}
                    fullWidth={true}
                    label={LOOKUP.report.common.subcategory.label}
                    floatingLabelText={LOOKUP.report.common.subcategory.label}
                    hintText={LOOKUP.report.common.subcategory.label}
                    options={props.productCategories && props.productCategories.length > 0 ? (props.isCannabis == 0 ? props.productCategories.filter(x => !x.isCannabis) : (props.isCannabis == 1 ? props.productCategories.filter(x => x.isCannabis) : props.productCategories)) : []}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-12 col-xl-5 mt-1 mb_xs p-0 pt-1"> 
                <Button
                    type="IconInButton"
                    className="pull-right ml-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
            {/* <Button
                className="pull-right mt-2 ml-1"
                mini={true}
                name={componentName + LOOKUP.report.common.exportExcel.name}
                label={LOOKUP.report.common.exportExcel.label}
            />
            <Button
                className="pull-right mt-2"
                mini={true}
                name={componentName + LOOKUP.report.common.print.name}
                label={LOOKUP.report.common.print.label}
            /> */}
        </div>
    </CardSimple>
);

export default Header;
